import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './CheckListSection.css';
import { FaCheck } from 'react-icons/fa'; // Import check icon

const CheckListSection = ({ mainTitle, checklistTitle, items }) => {
  const [checkedItems, setCheckedItems] = useState(items.map(item => ({ ...item, checked: false })));

  const handleCheckboxChange = (index) => {
    const updatedItems = [...checkedItems];
    updatedItems[index].checked = !updatedItems[index].checked;
    setCheckedItems(updatedItems);
  };

  return (
    <div className="document-checklist-container">
      <h1 className="document-checklist-main-title">{mainTitle}</h1>
      <h3 className="document-checklist-title">{checklistTitle}</h3>
      <ul className="document-checklist-list">
        {checkedItems.map((item, index) => (
          <li key={index} className="document-checklist-item">
            <div className="document-checklist-item-content">
              <label className="document-checklist-checkbox-label">
                <input
                  type="checkbox"
                  checked={item.checked}
                  onChange={() => handleCheckboxChange(index)}
                  className="document-checklist-checkbox"
                />
                 <span className={`checkmark ${item.checked ? 'checked' : ''}`}>
                  {item.checked && <FaCheck className="check-icon" />} {/* Use React Icon */}
                </span>
              </label>
              <span className="document-checklist-item-name">{item.name}</span>
              {item.description && <p className="document-checklist-item-description">{item.description}</p>}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

CheckListSection.propTypes = {
  mainTitle: PropTypes.string.isRequired,
  checklistTitle: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      description: PropTypes.string,
    })
  ).isRequired,
};

export default CheckListSection;
